import { useEffect, useState } from 'react';
//PACKAGES
import DataTable from 'react-data-table-component';
import moment from 'moment-timezone';
//COMPONENTS
import { CustomLoader } from '../../../components/CustomLoader'; 
import ReviewForm from './ReviewModal';
//FUNCTIONS
import {equipmentHealthTableInitializer} from '../services/equipmentHealthTableInitializer';


const EquipmentsHealthTable = () =>  {

	console.log('equipments table mounted')

	const [loadingEquipments, setLoadingEquipments] = useState(true)
	const [equipmentsData, setEquipmentsData] = useState([])
	const [searchText, setSearchText] = useState('');
	const [filteredEquipments, setFilteredEquipments] = useState([]);
	const [reviewFormModalVisible, setReviewFormModalVisible] = useState(false);
	const [deviceToReview, setDeviceToReview] = useState(null)

	const refresh = async () => {
		setLoadingEquipments(true);
		fetchData()
	}

	const fetchData = async () => {
		try {
			const equipment_data = await equipmentHealthTableInitializer()
			setEquipmentsData(equipment_data)
			setFilteredEquipments(equipment_data)
			setLoadingEquipments(false)
		} catch (error) {
			console.error("Error fetching equipments data:", error);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	useEffect(() => {
  	const filtered = equipmentsData.filter(equipment =>
    	equipment.equipment_name.toLowerCase().includes(searchText.toLowerCase())
  	);
  	setFilteredEquipments(filtered);
	}, [searchText]);

	useEffect(() => {
		if(deviceToReview){
			setReviewFormModalVisible(true)
		}
	}, [deviceToReview])


	const customStyles = {
		headCells: {
			style: {
				borderBottom: '1px solid rgb(112, 169, 213)',
				color: 'white',
				padding: '13px',
				backgroundColor: 'rgb(28, 75, 100)',
				borderSpacing: '0px',
				verticalAlign: 'middle',
			}
		}, 
		header: {
			style: {
				fontSize: '25px',
				fontWeight: 'bold',
				color: 'white',
				backgroundColor: 'rgb(6,25,83)',
				textAlign: 'center',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				marginBottom: '10px',
				borderRadius: '8px',
			},
		},
		headRow: {
		style: {
			borderRadius: '8px',
			overflow: 'hidden',
		}
	},
	};

	const columns = [
		{
			name: 'Equipment',
			selector: row => row.equipment_name,
			sortable: true,
			wrap: true
		},
		{
			name: 'Equipment Status',
			cell: row => {
				let bgColor = '';

				if (row.time_category_name === 'Down') bgColor = '#ed3030';
				else if (row.time_category_name === 'Operating') bgColor = '#76ed66';
				else if (row.time_category_name === 'Standby') bgColor = '#c9d4c8';
				else if (row.time_category_name === 'Delay') bgColor = '#f7f747';

				return (
					<div style={{ backgroundColor: bgColor, padding: '8px', borderRadius: '4px', width: '100%', textAlign: 'center' }}>
						{row.time_category_name}
					</div>
				);
			},
			center: true,
			wrap: true
		},
		{
			name: 'Main/Backup',
			selector: row => row.main ? 'Main' : 'Backup',
			sortable: true,
			center: true,
			wrap: true
		},
		{
			name: 'GPS Track ID',
			selector: row => row.user_name,
			sortable: true,
			center: true,
			wrap: true
		},
		{
			name: 'Last Seen',
			selector: row => moment(row.last_seen).tz("Pacific/Port_Moresby").format("HH:mm:ss, DD-MM-YYYY"),
			sortable: true,
			center: true,
			wrap: true
		},
		{
			name: 'Last Connection',
			selector: row => moment(row.last_connection).tz("Pacific/Port_Moresby").format("HH:mm:ss, DD-MM-YYYY"),
			sortable: true,
			center: true,
			wrap: true
		},
		{
			name: 'GPS',
			center: true,
			cell: row => (
				<div
					className={`p-2 rounded w-full text-black text-center font-semibold
						${
							row.gps_status === 'Ok' ? 'bg-green-500' :
							row.gps_status === 'to Check' ? 'bg-yellow-400' :
							row.gps_status === 'to Change' ? 'bg-red-500' :
							'text-black'
						}
					`}
				>
					{row.gps_status || 'Not Reviewed'}
				</div>
			),
			ignoreRowClick: true,
			wrap: true
		},
		{
			name: 'Cellular',
			center: true,
			cell: row => (
				<div
					className={`p-2 rounded w-full text-black text-center font-semibold
						${
							row.cellular_status === 'Ok' ? 'bg-green-500' :
							row.cellular_status === 'to Check' ? 'bg-yellow-400' :
							row.cellular_status === 'to Change' ? 'bg-red-500' :
							'text-black'
						}
					`}
				>
					{row.cellular_status || 'Not Reviewed'}
				</div>
			),
			ignoreRowClick: true,
			wrap: true
		},
		{
			name: 'Box',
			cell: row => (
				<div
					className={`p-2 rounded w-full text-black text-center font-semibold
						${
							row.box_status === 'Ok' ? 'bg-green-500' :
							row.box_status === 'to Check' ? 'bg-yellow-400' :
							row.box_status === 'to Change' ? 'bg-red-500' :
							'text-black'
						}
					`}
				>
					{row.box_status || 'Not Reviewed'}
				</div>
			),
			center: true,
			wrap: true
		},
		{
			name: 'Observation',
			selector: row => row.obs,
			center: true,
			wrap: true
		},
		{
			name: 'Last Review Date',
			selector: row => row.last_reviewed,
			center: true,
			wrap: true
		}
	];


	return(
		<div className="m-10">
			{ reviewFormModalVisible && (
				<ReviewForm
					control={{reviewFormModalVisible, setReviewFormModalVisible}}
					device={{deviceToReview, setDeviceToReview}}
					refresh={refresh}
				/>
			)}
			<DataTable
				title="Equipment Health"
				columns={columns}
				data={filteredEquipments}
				progressPending={loadingEquipments}
				progressComponent={<CustomLoader/>}
				highlightOnHover
				customStyles={customStyles}
				fixedHeader= {true}
				fixedHeaderScrollHeight="500px"
				subHeader= {true}
				subHeaderComponent={
					<div className="w-full flex justify-between">
						<div className="">
							<input
								type="text"
								placeholder="Search by name"
								className="border border-gray-300 rounded py-2"
								value={searchText}
								onChange={e => setSearchText(e.target.value)}
							/>
						</div>
					</div>
				}
				onRowClicked={(row) => {
					setDeviceToReview(row)
					console.log("Row clicked:", row);
				}}
			/>
		</div>
	)

}

export default EquipmentsHealthTable;